const Online_Icon = ({ className = "" }) => {
  return (
    <svg
      width="16"
      height="16"
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33325 15.521C12.3028 15.521 15.5208 12.303 15.5208 8.3335C15.5208 4.36395 12.3028 1.146 8.33325 1.146C4.36371 1.146 1.14575 4.36395 1.14575 8.3335C1.14575 12.303 4.36371 15.521 8.33325 15.521Z"
        fill="#79C8B0"
      />
      <path
        d="M8.33325 15.521C12.3028 15.521 15.5208 12.303 15.5208 8.3335C15.5208 4.36395 12.3028 1.146 8.33325 1.146C4.36371 1.146 1.14575 4.36395 1.14575 8.3335C1.14575 12.303 4.36371 15.521 8.33325 15.521Z"
        fill="url(#paint0_linear_462_8766)"
      />
      <path
        d="M7.55216 11.1981C7.34383 11.4064 6.97925 11.4064 6.71883 11.1981L4.47925 8.9585C4.16675 8.646 4.16675 8.17725 4.47925 7.86475C4.79175 7.55225 5.2605 7.55225 5.573 7.86475L7.1355 9.42725L11.0417 5.521C11.3542 5.2085 11.823 5.2085 12.1355 5.521C12.448 5.8335 12.448 6.30225 12.1355 6.61475L7.55216 11.1981Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_462_8766"
          x1="12.8254"
          y1="13.1252"
          x2="4.47797"
          y2="5.2138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Online_Icon;
